import api from "@/api.js";

export default {
  namespaced: true,
  modules: {

  },
  state: {
    list: [],
    listLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
  },
  actions: {
    async loadAllSolutionsSourcesBySolutionID({ commit }, solutions_id) {
      commit("setListLoading", true);
      let list = await api.get("solutions/impact/bySolutionsID", {
        params: { id: solutions_id }
      });
      commit("setSolutionsSourcesList", list.data);
      commit("setListLoading", false);
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
  }
}
